import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faSearch} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401, Msg403, Msg500 } from '../Messages/Messages';
import search from '../Components/Search';
import Search from '../Components/Search';
import Pagination, { usePagination } from '../Components/Pagination';
import { decryptData } from '../../utils/storageCrypto';
import { UserIcon} from '@heroicons/react/24/outline';


const Allvendors = () => {
  const navigate = useNavigate();
  const [vendors, setvendors] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [retryFunction, setRetryFunction] = useState(null);
  const [selectedVendors, setSelectedVendors] = useState([]); // Add this state
  const [selectAll, setSelectAll] = useState(false); // Add this state
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [filteredVenors, setFilteredVendors] = useState([]);
  const searchTypes = ['Business Name', 'Mobile Number', 'Owner Name', 'Vendor Type', 'Item Category' ,];
const [searchType, setSearchType] = useState(''); // default
const [searchChips, setSearchChips] = useState(() => {
  try {
    return JSON.parse(sessionStorage.getItem('vendorsSearchChips')) || [];
  } catch {
    return [];
  }
});

const vendorsToDisplay = searchQuery || searchType ? filteredVenors : vendors;

const {
  currentItems,
  currentPage,
  totalPages,
  totalItems,
  handlePageChange,
  handlePreviousPage,
  handleNextPage,
  resetToFirstPage
} = usePagination(vendorsToDisplay, 10);

  const getStatusColor = (status) => {
    switch (status) {
      case 'DRAFT':
        return 'text-gray-500';
      case 'INVOICED':
        return 'text-green-500';
      case 'SENT':
        return 'text-blue-500';
      default:
        return '';
    }
  };

  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedArray = [...vendors].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
    setvendors(sortedArray);
resetToFirstPage()
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
    }
    return null;
  };

  useEffect(() => {
    if (vendors.length > 0) {
      if (searchQuery && searchType) {
        handleSearch(searchQuery, searchType);
      } else {
        setFilteredVendors(vendors);
      }
    }
  }, [vendors]);

  
useEffect(() => {
  const savedSearchChips = JSON.parse(sessionStorage.getItem('vendorsSearchChips')) || [];
  setSearchChips(savedSearchChips);

  if (savedSearchChips.length > 0) {
    const lastChip = savedSearchChips[0];
    setSearchQuery(lastChip.query);
    setSearchType(lastChip.type);
  }

  fetchVendors();
}, []);

  useEffect(() => {
      if (searchQuery && searchType) {
        const newChip = [{
          query: searchQuery,
          type: searchType
        }];
    
        setSearchChips(newChip);
        sessionStorage.setItem('vendorsSearchChips', JSON.stringify(newChip));
      }
    }, [searchQuery, searchType]);


 const handleSearch = (query, type) => {
   sessionStorage.setItem('vendorsSearchQuery', query || '');
  sessionStorage.setItem('vendorsSearchType', type || '');
  if (!query || query.trim() === '') {
    setFilteredVendors(vendors);
     setSearchChips([]);
  sessionStorage.removeItem('vendorsSearchChips');
   sessionStorage.removeItem('vendorsSearchQuery');
    sessionStorage.removeItem('vendorsSearchType');
    resetToFirstPage(); 
    return;
  }

  const lowercaseQuery = (query || '').toLowerCase();

  const filtered = vendors.filter((vendor) => {
    switch (type) {
      case 'Business Name':
        return vendor.company_name?.toLowerCase().includes(lowercaseQuery);
      case 'Mobile Number':
        return vendor.mobile_number?.toLowerCase().includes(lowercaseQuery);  
      case 'Owner Name':
        return vendor.name?.toLowerCase().includes(lowercaseQuery);
      case 'Vendor Type':
        return vendor.vendor_type?.toLowerCase().includes(lowercaseQuery);
      case 'Item Category':
        return vendor.categories?.some(category =>
          category.toLowerCase().includes(lowercaseQuery)
        );
      default:
        return false;
    }
  });

  setFilteredVendors(filtered);
  resetToFirstPage(); 
};


const handleAddSearchChip = (query, type) => {
  if (!type) return;

  const actualQuery = query.trim();

  const newChip = [{ query: actualQuery, type }]; // only one chip

  setSearchChips(newChip);
  sessionStorage.setItem('vendorsSearchChips', JSON.stringify(newChip));
  sessionStorage.setItem('vendorsSearchQuery', actualQuery);
  sessionStorage.setItem('vendorsSearchType', type);


  setSearchQuery(actualQuery);
  setSearchType(type);

  handleSearch(actualQuery, type);
};

const handleChipClick = (chip) => {
  setSearchType(chip.type);
  setSearchQuery(chip.query);
  handleSearch(chip.query, chip.type);
};


const handleRemoveSearchChip = () => {
  setSearchChips([]);
  sessionStorage.removeItem('vendorsSearchChips');
sessionStorage.removeItem('vendorsSearchQuery');
  sessionStorage.removeItem('vendorsSearchType');

  setSearchQuery('');
  setSearchType('');
    setFilteredVendors(vendors);
};


  const fetchVendors = async (attempt = 1) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedhubId = sessionStorage.getItem('hubId');
                const hubId = decryptData(encryptedhubId);
      const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `vendor/get-all-vendors?hubId=${hubId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });

      const data = await response.json();
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        setvendors(data.data); // Update vendors state
        setIsLoading(false);
        console.log(data.data);
      }else if (data.status === 500) {
        setIsLoading(false);
        setRetryFunction(() => fetchVendors);
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
      } 
      else {
        setIsLoading(false);
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchVendors(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchVendors(attempt)); // Set retry function
      }
    }
  };

  {/* get-vendorsBy-productCategoryId */}

  useEffect(() => {
    fetchVendors();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  const handleCheckboxChange = (vendor) => {
    if (selectedVendors.includes(vendor)) {
      setSelectedVendors(selectedVendors.filter((v) => v !== vendor));
      setSelectAll(false); // Update selectAll state when deselecting a checkbox
    } else {
      setSelectedVendors([...selectedVendors, vendor]);
      if (selectedVendors.length === vendors.length - 1) {
        setSelectAll(true); // Update selectAll state when selecting all checkboxes
      }
    }
  };
  
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedVendors([]);
      setSelectAll(false);
    } else {
      setSelectedVendors(vendors);
      setSelectAll(true);
    }
  };

  const handleDelete = async (attempt = 1) => {
    const selectedVendorIds = selectedVendors.map((vendor) => vendor._id);
    console.log(selectedVendorIds);
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedhubId = sessionStorage.getItem('hubId');
                const hubId = decryptData(encryptedhubId);
      const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "vendor/delete-vendors", {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({ vendorIds: selectedVendorIds })
      });
  
      const data = await response.json();
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        // Update the vendors state to reflect the deleted vendors
        setvendors(vendors.filter((vendor) => !selectedVendorIds.includes(vendor.id)));
        setSelectedVendors([]);
        setSelectAll(false);
        resetToFirstPage();
      } else {
        // Handle error cases
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleDelete(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleDelete(attempt)); // Set retry function
      }
    }
  };

  const handleCreate = () => {
    navigate("/admin/app/purchases/newvendor");
  };

  const handleNavigateVendorDetails = (vendor) => {
    navigate("/admin/app/purchases/vendordetails", { state: { VendorData: vendor } });
  };

  const closePopup = () => {
    console.log("closePopup called");
    setShowPopup(false);
  };

  const Retry = async () => {
    console.log("Retry called");
    setIsLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction();
      }
      setIsLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopup(false);
  };

  const BackToLoginPage = () => {
    console.log("Back To Login Page");
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
    navigate('/admin');
  };

  return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex w-full flex-row">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between ">
              <div className="w-full h-16 border-b flex items-center">
              <div className="flex w-full justify-between px-6 items-center">
  {selectedVendors.length > 0 ? (
    <button onClick={handleDelete}
      className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md ">Delete</button>
  ) : (
    <>
     <div className='space-x-10 flex flex-row mt-4 mb-4'>
      <h1 className="text-lg font-bold whitespace-nowrap ">All vendors</h1>
      {vendors.length > 0 && (
        <>
    <Search
  searchQuery={searchQuery}
  setSearchQuery={setSearchQuery}
  searchType={searchType}
  setSearchType={setSearchType}
  searchTypes={searchTypes}
  onSearch={handleSearch}
  onSearchSubmit={handleAddSearchChip}
  placeholder="Search vendors..."
/>
    

{searchChips.length > 0 && (
  <div className="w-full flex flex-cols gap-3 items-center mt-2 px-4">
    {searchChips.map((chip, index) => {
      const isActive = chip.type === searchType;

      const chipClasses = `flex items-center max-w-xs text-sm px-3 py-1 rounded-full shadow-sm transition-all duration-150 ${
        isActive
          ? 'bg-red-500 text-white'
          : 'bg-gray-100 text-gray-800'
      }`;

      return (
        <div
        key={`${chip.type}-${chip.query}-${index}`} // Better unique key
      className={chipClasses}
      style={{ whiteSpace: 'nowrap' }}
      onClick={() => handleChipClick(chip)}
    >
      <span className="whitespace-nowrap ">
        {chip.type}: {chip.query}
      </span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveSearchChip(chip);
            }}
            className={`ml-2 text-base font-bold ${
              isActive ? 'text-white hover:text-gray-200' : 'text-gray-500 hover:text-red-500'
            }`}
          >
            ×
          </button>
        </div>
      );
    })}
  </div>
)}

</>
  )}


        </div>
      <button onClick={handleCreate}
        className="bg-[#E54643] text-white z-20 px-2 py-1 rounded"
        title="" data-tooltip="Create Vendor"  style={{ '--tooltip-bg': 'black' }}>+ New</button>
    </>
  )}
</div>
              </div>

               <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                itemsPerPage={10}
                 showInfo={true}
                  hideControls={true} 
                itemName="vendors"
              />

              <div className="w-full h-full bg-white rounded-xs overflow-hidden ">
                <div className="overflow-y-auto h-[70vh] pb-10 ">
                  {vendors.length > 0 ? (
                    <table className="w-full mb-5 ">
                      <thead className="sticky top-0  bg-[#fafafc] text-[#6c7184] border-b ">
                        <tr className='border-b'>
                        <th className="text-xs py-3 text-center ">
                        <input
        type="checkbox"
        className="mr-2"
        onChange={handleSelectAll}
        checked={selectAll}
      />
    </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('company_name')}>
                            BUSINESS NAME {getSortIcon('company_name') && <FontAwesomeIcon icon={getSortIcon('company_name')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('mobile_number')}>
                            MOBILE NUMBER {getSortIcon('mobile_number') && <FontAwesomeIcon icon={getSortIcon('mobile_number')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('name')}>
                            OWNER NAME {getSortIcon('name') && <FontAwesomeIcon icon={getSortIcon('name')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('categories')}>
                            ITEM CATEGORY {getSortIcon('categories') && <FontAwesomeIcon icon={getSortIcon('categories')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('vendor_type')}>
                            VENDOR TYPE {getSortIcon('vendor type') && <FontAwesomeIcon icon={getSortIcon('vendor_type')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('city')}>
                            CITY {getSortIcon('city') && <FontAwesomeIcon icon={getSortIcon('city')} />}
                          </th>
                          <th className="text-xs py-3 text-center cursor-pointer" onClick={() => sortArray('state')}>
                            STATE {getSortIcon('state') && <FontAwesomeIcon icon={getSortIcon('state')} />}
                          </th>
                          <th className="text-xs py-3 text-center">STATUS</th>
                        </tr>
                      </thead>
                      <tbody className='border-b border-t max-h-[60vh] overflow-y-auto'>
              {currentItems.length > 0 ? (
currentItems.map((vendor) => (
                           <tr key={vendor._id} className="text-sm border-b">
                           <td className="py-2 text-center">
                             <input
                               type="checkbox"
                               className="mr-2"
                               onChange={(e) => handleCheckboxChange(vendor)}
                               checked={selectedVendors.includes(vendor) || selectAll}
                             />
                           </td>
                            <td onClick={() => handleNavigateVendorDetails(vendor)}
                              className="py-2 text-center text-[#408dfb] font-500 cursor-pointer">{vendor.company_name}</td>
                            <td className="py-2 text-center">{vendor.mobile_number}</td>
                            <td className="py-2 text-center">{vendor.name}</td>
                        <td className="py-2 text-center max-w-[160px]">
  <div className="leading-tight break-words max-h-[60px] overflow-y-auto">
    {vendor.categories?.join(', ') || 'N/A'}
  </div>
</td>
                            <td className="py-2 text-center">{vendor.vendor_type}</td>
                            <td className="py-2 text-center">{vendor.city}</td>
                            <td className={`py-2 text-center ${getStatusColor(vendor.mobile_number)}`}>{vendor.state}</td>
                            <td className="py-2 text-center">{vendor.is_active ? 'Active' : 'deactive'}</td>
                          </tr>
                        ))
                       ) : (
                        <tr>
                          <td
                            colSpan="10"
                            className="text-center text-[#6c7184] py-4"
                          >
                           <div className="flex flex-col items-center">
                                                         <FontAwesomeIcon icon={faSearch} className="text-4xl text-gray-300 mb-4" />
                                                         <p className="text-lg font-medium mb-2">No results found.</p>
                                                         <p className="text-sm">Try adjusting your search criteria.</p>
                                                       </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                ) : (
                    <>
                      {/* <div className="m-4 p-4 text-center border border-grey-500 text-gray-500">
                        No Vendors Found.
                      </div> */}
                      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8 mx-4 mt-4">
                  <div className="text-center text-gray-500">
                    <div className="mb-4">
                      <UserIcon className="mx-auto h-12 w-12 text-gray-300" />
                    </div>
                    <h3 className="text-lg font-medium mb-2">No Vendors Found</h3>
                    <p className="text-sm">Vendors will appear here once they are created.</p>
                  </div>
        <div className="flex justify-center items-center mt-4">
            <button className="bg-[#F7525A] text-white px-2 py-1 rounded-md" onClick={handleCreate}>Create</button>
        </div>
        </div>
                    </>
                  )}
                </div>
              </div>
             <div className="sticky bottom-0 bg-white shadow-md z-10 px-4 py-2">

               <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                itemsPerPage={10}
                onPageChange={handlePageChange}
                onPreviousPage={handlePreviousPage}
                onNextPage={handleNextPage}
                  showInfo={false}
                itemName="Vendors"
              />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPopup && (
        <div>
          {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
          {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
          {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
        </div>
      )}
    </div>
  );
};

export default Allvendors;
